module.exports = __webpack_public_path__ + "static/img/chery_6@2x.4d051cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/productCase/chery_6@2x.png
// module id = wiGR
// module chunks = 0